import React, { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { message, Spin } from "antd";

function Contact() {
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    fetchContactInfo();
  }, []);

  // ✅ Fetch Contact Information
  const fetchContactInfo = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/contactInfo");
      setContactInfo(response.data);
    } catch (error) {
      message.error("Failed to load contact info.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle Input Changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate input fields
    if (!formData.fullName || !formData.email || !formData.message) {
      message.error("All fields are required.");
      return;
    }

    try {
      await axios.post("http://93.127.203.113:5005/contact", formData);
      message.success("Message sent successfully!");
      setFormData({ fullName: "", email: "", message: "" }); // Reset form
    } catch (error) {
      message.error("Failed to send message. Try again later.");
    }
  };

  return (
    <>
      <section className="contact-page">
        <HeroPages name="Contact" />
        <div className="container">
          <div className="contact-div">
            {/* Left: Contact Info */}
            <div className="contact-div__text">
              {loading ? (
                <Spin size="large" />
              ) : contactInfo ? (
                <>
                  <h2>{contactInfo.title}</h2>
                  <p>{contactInfo.description}</p>
                  <a href={`tel:${contactInfo.phone}`}>
                    <i className="fa-solid fa-phone"></i>&nbsp; {contactInfo.phone}
                  </a>
                  <a href={`mailto:${contactInfo.email}`}>
                    <i className="fa-solid fa-envelope"></i>&nbsp; {contactInfo.email}
                  </a>
                  <a href="/">
                    <i className="fa-solid fa-location-dot"></i>&nbsp; {contactInfo.location}
                  </a>
                </>
              ) : (
                <p>No contact info available.</p>
              )}
            </div>

            {/* Right: Contact Form */}
            <div className="contact-div__form">
              <form onSubmit={handleSubmit}>
                <label>
                  Full Name <b>*</b>
                </label>
                <input
                  type="text"
                  name="fullName"
                  placeholder='E.g: "Adam Ad"'
                  value={formData.fullName}
                  onChange={handleChange}
                />

                <label>
                  Email <b>*</b>
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="youremail@example.com"
                  value={formData.email}
                  onChange={handleChange}
                />

                <label>
                  Tell us about it <b>*</b>
                </label>
                <textarea
                  name="message"
                  placeholder="Write Here.."
                  value={formData.message}
                  onChange={handleChange}
                />

                <button type="submit">
                  <i className="fa-solid fa-envelope-open-text"></i>&nbsp; Send Message
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Book Banner */}
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a car by getting in touch with us</h2>
              <span>
                <i className="fa-solid fa-phone"></i>
                <h3>{contactInfo?.phone || "(123) 456-7869"}</h3>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Contact;
